import { defineComponent, getCurrentInstance } from 'vue';
// import Auth from '@/store/modules/auth'
// import { Route } from 'vue-router'
export default defineComponent({
    setup(props) {
        const root = getCurrentInstance().proxy;
        const gAuth = root.$gAuth;
        // const auth = getModule(Auth, root.$store)
        const signInByGoogleToken = (token) => root.$store.dispatch('auth/signInByGoogleToken', token);
        //
        // const redirect = ref('')
        // const otherQuery = ref('')
        //
        // watch(() => root.$route, (route: Route) => {
        //   getOtherQuery(route)
        // }, { immediate: true })
        //
        // function getOtherQuery(query: any) {
        //   return Object.keys(query).reduce((acc, cur) => {
        //     if (cur !== 'redirect') {
        //       acc[cur] = query[cur]
        //     }
        //     return acc
        //   }, {} as any)
        // }
        async function signin() {
            const { id_token } = await gAuth.signIn(); // eslint-disable-line
            await signInByGoogleToken(id_token);
        }
        async function login() {
            try {
                await signin();
                /*
                const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJmb3h4aW5nLmNvbSIsInN1YiI6ImZveHhpbmctand0IiwiYXVkIjoiYXV0aC5jbG8zZC5jb20iLCJlbWFpbCI6ImJvYkBmb3h4aW5nLmNvbSIsIm5hbWUiOiJCb2IgSnVuZyIsInJvbGUiOjk5LCJpYXQiOjE2NDk0ODYyMjcsIm5iZiI6MTY0OTQ4NjIyNywiZXhwIjoxNjQ5NTI5NDI3fQ.b_MP4B4YdAyhFgOJNlM8prr7Fr9-XDK3pZu1Qrq-s9E'
                root.$store.commit('auth/setTokens', {
                  accessToken: token,
                  refreshToken: token,
                  user: {
                    email: 'adsf',
                    name: 'asdf'
                  }
                })
         */
                root.$router.push({ path: '/' });
            }
            catch (e) {
                console.log(e);
                alert('An error occurred while logging in. Please contact manager');
            }
        }
        return {
            login
        };
    }
});
